const roleFallbacks = {
  customer: '/fleet_dashboard',
  technician: '/technician-dashboard',
  operator: '/operator',
};

function isSafeInternalPath(value) {
  if (typeof value !== 'string') return false;
  // Browsers normalize backslashes and strip controls when parsing URLs.
  // eslint-disable-next-line no-control-regex -- Reject URL control-character bypasses.
  if (/[\\\u0000-\u001f\u007f]/.test(value)) return false;
  const path = value.trim();
  return path.startsWith('/') && !path.startsWith('//');
}

function stateToPath(value) {
  if (isSafeInternalPath(value)) return value.trim();
  if (!value || typeof value !== 'object') return '';

  const pathname = value.pathname;
  if (!isSafeInternalPath(pathname)) return '';

  const search = typeof value.search === 'string' && value.search.startsWith('?') ? value.search : '';
  const hash = typeof value.hash === 'string' && value.hash.startsWith('#') ? value.hash : '';
  const path = `${pathname.trim()}${search}${hash}`;
  return isSafeInternalPath(path) ? path : '';
}

function roleFromPath(pathname) {
  if (pathname?.startsWith('/customer/')) return 'customer';
  if (pathname?.startsWith('/technician/')) return 'technician';
  if (pathname?.startsWith('/operator')) return 'operator';
  return '';
}

export function getRecordReturnTarget(location, role) {
  const state = location?.state || {};
  const stateReturnTarget = stateToPath(state.returnTo) || stateToPath(state.from);
  if (stateReturnTarget) return stateReturnTarget;

  const roleKey = roleFromPath(location?.pathname) || String(role || '').toLowerCase();
  return roleFallbacks[roleKey] || '/';
}
